import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import snackbar from "../snackbar";
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
    close: {
        padding: theme.spacing.unit / 2,
    },
});

class ConsecutiveSnackbars extends React.Component {
    queue = [];

    state = {
        open: false,
        messageInfo: {},
    };

    componentWillMount() {
        snackbar.setMessage = (message, config) => {
            config = config || {};
            this.queue.push({
                message,
                config,
                key: new Date().getTime(),
            });

            if (this.state.open) {
                // immediately begin dismissing current message
                // to start showing new one
                this.setState({open: false});
            } else {
                this.processQueue();
            }
        };
    }


    processQueue = () => {
        if (this.queue.length > 0) {
            this.setState({
                messageInfo: this.queue.shift(),
                open: true,
            });
        }
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({open: false});
    };

    handleExited = () => {
        this.processQueue();
    };

    render() {
        const {classes} = this.props;
        const {messageInfo} = this.state;
        let actions = [
            <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={this.handleClose}
            >
                <CloseIcon/>
            </IconButton>,
        ];

        if (messageInfo && messageInfo.config && messageInfo.config.action) {
            actions.unshift(
                <Button key="action" color="secondary" size="small" onClick={() => {
                    messageInfo.config.action.action();
                    this.handleClose();
                }}>
                    {messageInfo.config.actionText}
                </Button>)
        }

        return (
            <div>
                <Snackbar
                    key={messageInfo.key}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={this.state.open}
                    autoHideDuration={6000}
                    onClose={this.handleClose}
                    onExited={this.handleExited}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{messageInfo.message}</span>}
                    action={actions}
                />
            </div>
        );
    }
}

ConsecutiveSnackbars.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ConsecutiveSnackbars);